import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

export const useEditorOnboardingEvents = (): {
	fireGetEditorOnboardingStateFailed: (source: any) => void;
	fireEditorPublishSuccessFlagViewed: (type: any) => void;
	fireEditorModalPromptClosed: () => void;
	fireEditorModalPromptPublished: () => void;
} => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireGetEditorOnboardingStateFailed = useCallback(
		(source: any): void => {
			createAnalyticsEvent({
				type: 'sendOperationalEvent',
				data: {
					action: 'failed',
					actionSubject: 'getOnboardingState',
					actionSubjectId: 'editorOnboarding',
					source,
				},
			}).fire();
		},
		[createAnalyticsEvent],
	);

	const fireEditorPublishSuccessFlagViewed = useCallback(
		(type: any): void => {
			createAnalyticsEvent({
				type: 'sendScreenEvent',
				data: {
					name: 'onboardingEditorPublishSuccessFlag',
					attributes: {
						type,
					},
				},
			}).fire();
		},
		[createAnalyticsEvent],
	);

	const fireEditorModalPromptClosed = useCallback((): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'onboardingEditorModalPrompt',
				actionSubject: 'button',
				action: 'clicked',
				actionSubjectId: 'closeButton',
			},
		}).fire();
	}, [createAnalyticsEvent]);

	const fireEditorModalPromptPublished = useCallback((): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'onboardingEditorModalPrompt',
				actionSubject: 'button',
				action: 'clicked',
				actionSubjectId: 'publishButton',
			},
		}).fire();
	}, [createAnalyticsEvent]);

	return {
		fireGetEditorOnboardingStateFailed,
		fireEditorPublishSuccessFlagViewed,
		fireEditorModalPromptClosed,
		fireEditorModalPromptPublished,
	};
};
